/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfFileResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type PaginatedResultOfFileResponse } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /search/files
 */
export interface FilesRequestBuilder extends BaseRequestBuilder<FilesRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfFileResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<FilesRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfFileResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<FilesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface FilesRequestBuilderGetQueryParameters {
    page?: number;
    pageSize?: number;
    q?: string;
}
/**
 * Uri template for the request builder.
 */
export const FilesRequestBuilderUriTemplate = "{+baseurl}/search/files{?page*,pageSize*,q*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const FilesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: FilesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfFileResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
